"use client";

import Link from "next/link";
import { useParams } from "next/navigation";
import { useState } from "react";
import Image from "next/image";
import { headerTexts } from "@/lib/sharedTranslations";

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const params = useParams();
  const locale = (params?.locale as "pt" | "en") ?? "pt";
  const t = headerTexts[locale] ?? headerTexts["pt"];

  return (
    <header className="relative bg-[#F7F2E3] z-50">
      <div className="bg-[#1B475D] max-w-7xl mx-auto px-6 py-6 flex justify-between items-center">
        <Link href={`/${locale}`} className="flex items-center gap-2">
          <Image src="/images/ghlogo.png" alt="Logo" width={40} height={40} />
          <span className="text-2xl md:text-3xl font-bold text-[#F1F5F9]">
            Genau Hub
          </span>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-6 font-medium text-[#F1F5F9]">
          <Link href={`/${locale}`} className="hover:underline">
            {t.home}
          </Link>
          <Link href={`/${locale}/services`} className="hover:underline">
            {t.services}
          </Link>
          <Link href={`/${locale}/professionals`} className="hover:underline">
            {t.professionals}
          </Link>
          <Link href={`/${locale}/community`} className="hover:underline">
            {t.community}
          </Link>
          <Link href={`/${locale}/places`} className="hover:underline">
            {t.places}
          </Link>
          <Link href={`/${locale}/about`} className="hover:underline">
            {t.about}
          </Link>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-3xl text-[#F1F5F9]"
          onClick={() => setIsOpen((prev) => !prev)}
          aria-label="Toggle menu"
          aria-expanded={isOpen}
          aria-controls="mobile-menu"
        >
          {isOpen ? "✕" : "☰"}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div
          id="mobile-menu"
          className="md:hidden absolute top-full left-0 w-full bg-[rgba(142,189,157,0.85)] border-t border-[#D3DC7C] px-6 py-6 shadow-lg z-50 backdrop-blur-sm"
        >
          <nav className="flex flex-col space-y-4 font-medium text-[#1B475D]">
            <Link href={`/${locale}/services`} onClick={() => setIsOpen(false)}>
              {t.services}
            </Link>
            <Link href={`/${locale}/professionals`} className="hover:underline">
              {t.professionals}
            </Link>
            <Link href={`/${locale}/community`} onClick={() => setIsOpen(false)}>
              {t.community}
            </Link>
            <Link href={`/${locale}/places`} onClick={() => setIsOpen(false)}>
              {t.places}
            </Link>
            <Link href={`/${locale}/about`} onClick={() => setIsOpen(false)}>
              {t.about}
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
